/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_intersection.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the geometric intersection of two geometries. The result is a geometry representing the portion that both input geometries have in common. Returns an empty geometry if the inputs do not intersect. Both geometries must share the same coordinate reference system.
 *
 * @example
 * ROW a = TO_GEOSHAPE("POLYGON ((0 0, 3 0, 3 3, 0 3, 0 0))"),
 *     b = TO_GEOSHAPE("POLYGON ((1 1, 4 1, 4 4, 1 4, 1 1))")
 * | EVAL intersected = ST_INTERSECTION(a, b)
 * | KEEP intersected
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'st_intersection',
  signatures: [
    {
      params: [
        {
          name: 'geomA',
          type: 'cartesian_point',
          optional: false,
        },
        {
          name: 'geomB',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'cartesian_shape',
    },
    {
      params: [
        {
          name: 'geomA',
          type: 'cartesian_point',
          optional: false,
        },
        {
          name: 'geomB',
          type: 'cartesian_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'cartesian_shape',
    },
    {
      params: [
        {
          name: 'geomA',
          type: 'cartesian_shape',
          optional: false,
        },
        {
          name: 'geomB',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'cartesian_shape',
    },
    {
      params: [
        {
          name: 'geomA',
          type: 'cartesian_shape',
          optional: false,
        },
        {
          name: 'geomB',
          type: 'cartesian_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'cartesian_shape',
    },
    {
      params: [
        {
          name: 'geomA',
          type: 'geo_point',
          optional: false,
        },
        {
          name: 'geomB',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geo_shape',
    },
    {
      params: [
        {
          name: 'geomA',
          type: 'geo_point',
          optional: false,
        },
        {
          name: 'geomB',
          type: 'geo_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geo_shape',
    },
    {
      params: [
        {
          name: 'geomA',
          type: 'geo_shape',
          optional: false,
        },
        {
          name: 'geomB',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geo_shape',
    },
    {
      params: [
        {
          name: 'geomA',
          type: 'geo_shape',
          optional: false,
        },
        {
          name: 'geomB',
          type: 'geo_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geo_shape',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
